import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Label } from "recharts";
import moment from "moment";

const ChartComponent = ({ data, date_type = "month", width = 450 }) => {
  const lastSixMonths = Array.from({ length: 6 }).map((_, i) =>
    moment()
      .subtract(i, date_type + "s")
      .startOf(date_type)
      .toDate()
  );
  const counts = lastSixMonths
    .map((date) => {
      const endOfMonth = moment(date).endOf(date_type).toDate();
      return {
        name: moment(date).format(date_type === "week" ? "MMM DD" : "MMM YYYY"),
        count: data.filter((item) => new Date(item.date) >= date && new Date(item.date) <= endOfMonth).length
      };
    })
    .reverse();

  return (
    <LineChart
      width={width}
      height={350}
      data={counts}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name">
        <Label value={date_type + "s"} offset={-5} position="insideBottom" />
      </XAxis>
      <YAxis label={{ value: "Count", angle: -90, position: "insideLeft" }} />
      <Tooltip />
      <Line type="monotone" dataKey="count" stroke="#8884d8" activeDot={{ r: 8 }} />
    </LineChart>
  );
};

export default ChartComponent;
